import React, { useState } from 'react'
import Sidebar from '../components/Sidebar'
import { Outlet } from 'react-router-dom'
import Header from '../../components/Header/Header'
import img from "../assets/SVG___twist_line_spiral_artistic_-_Free_SVG_Image___Icon____SVG_Silh-removebg-preview.png"
import Notification from '../../../components/Notification'

const Layout = () => {
    const [showScroll, setshowScroll] = useState(true)
  const [showNotif, setShowNotif] = useState({
    show: false,
    message:"Une erreur est survenue",
    variant: "danger"
  })
    return (
        <>
            <Header />
            <div className='flex mt-14 w-full overflow-x-hidden'>
                <div className="fixed -bottom-40 -left-80 z-20 opacity-10 xl:block hidden">
                    <img src={img}/>
                </div>
                <Sidebar/>
                <Outlet context={{showScroll, setshowScroll, showNotif, setShowNotif}}/>
            </div>
            <Notification variant={showNotif.variant} text={showNotif.message} isOpen={showNotif.show} setIsOpen={()=>setShowNotif({...showNotif, show: false})} />                
        </>
      )
}

export default Layout